import React from 'react';
import Seo from '../../components/Seo';

function Privacidad() {
  return (
    <div className="page page--narrow">
      <Seo title="Política de privacidad" />
      <h1>Política de privacidad</h1>
      <p>
        Libros para Viajeros trata los datos personales que facilitas a través de los formularios de contacto y
        newsletter (nombre, email y, en su caso, empresa/editorial y mensaje) con la única finalidad de responder
        a tu solicitud o enviarte la newsletter a la que te has suscrito, conforme al RGPD.
      </p>
      <p>
        Pendiente de completar con el resto de menciones obligatorias (responsable del tratamiento, base
        legitimadora detallada, plazos de conservación, derechos ARCO+ y forma de ejercerlos, y encargados de
        tratamiento como el proveedor de hosting, base de datos y envío de emails).
      </p>
    </div>
  );
}

export default Privacidad;
